import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Depress.module.css';
import { DBRadioButton } from '_components';


class PatientCareCenterNoteSubjectiveDepress extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='sub_depress' name='Depression' level={1}>
                <div className={styles.row}>
                    <label className={styles.col1} >Over the past 2 weeks, how often have you been bothered by any of the following problems?</label>
                </div>
                <div className={styles.row}>
                    <label className={styles.col2} >Little interest or pleasure in doing things</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.spacer} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBDEPINTEREST'
                        label='Not at all'
                        selectedValue='Not at all'
                        className={styles.radio1}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBDEPINTEREST'
                        label='Several days'
                        selectedValue='Several days'
                        className={styles.radio2}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBDEPINTEREST'
                        label='More than half the days'
                        selectedValue='More than half the days'
                        className={styles.radio3}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBDEPINTEREST'
                        label='Nearly every day'
                        selectedValue='Nearly every day'
                        className={styles.radio4}
                    />
                </div>

                <div className={styles.row}>
                    <label className={styles.col2} >Feeling down, depressed or hopeless</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.spacer} />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBDEPDOWN'
                        label='Not at all'
                        selectedValue='Not at all'
                        className={styles.radio1}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBDEPDOWN'
                        label='Several days'
                        selectedValue='Several days'
                        className={styles.radio2}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBDEPDOWN'
                        label='More than half the days'
                        selectedValue='More than half the days'
                        className={styles.radio3}
                    />
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTEVAL'
                        entityKeyColumn='EVNO'
                        entityKeyValue={this.props.evno}
                        field='EVSUBDEPDOWN'
                        label='Nearly every day'
                        selectedValue='Nearly every day'
                        className={styles.radio4}
                    />
                </div>
            </PatientCareCenterNoteSection>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);

    return {
        noteId: noteId,
        evno: evno,
    };
}

const connectedPatientCareCenterNoteSubjectiveDepress = connect(mapStateToProps)(PatientCareCenterNoteSubjectiveDepress);
export { connectedPatientCareCenterNoteSubjectiveDepress as PatientCareCenterNoteSubjectiveDepress };

